angular.module('CarsSaraBo').controller('OneWayController',
	['$scope', '$routeParams','$q','OneWayService','OneWayServiceAll','$http','$filter', 'GAService', 'NotificationService', 'LoadingWheelService',
		function($scope, $routeParams,$q,oneWayService,oneWayServiceAll,$http,$filter, gaService, notificationService, loadingWheelService) {
	
	$scope.initialize = function() {
		$scope.hasNotCharge=false;
		$scope.oneWayMap = {};
		$scope.loadCompany();
		$scope.loadData();
		$scope.amount;
		$scope.errorField={};
		$scope.config = {
				itemsPerPage:10,
				currentPage:1,
				numPages:0,
				totalItems:0
			}
		$scope.pageOneWayList = [];
		$scope.isCollapsed = false;
		$scope.collapsed = 'up';
	}
	
	$scope.loadCompany = function(){
        loadingWheelService.show();
		oneWayServiceAll.get({companyOid: $routeParams.oid }, function(response) {
			$scope.oneWayMap = response;
			$scope.originOneWayMap =  angular.copy(response);
			$scope.config.totalItems = $scope.oneWayMap.length;
			$scope.config.numPages=Math.floor($scope.oneWayMap.length/$scope.config.itemsPerPage);
			$scope.changePage();
            loadingWheelService.hide();
		});
	}
	
	$scope.changePage = function(){
		var startItem = $scope.config.itemsPerPage * $scope.config.currentPage;
		$scope.pageOneWayList = $scope.oneWayMap.slice(startItem - $scope.config.itemsPerPage, startItem);
	}
	
	$scope.loadData = function(){
		$http.get("../rest/data/locationsName/" + $routeParams.oid).success(function(response) {
			$scope.locationsName = response;
			});
	}
	
	$scope.hasMoreThanOneLocation = function(){
		return !$scope.locationsName || (Object.keys($scope.locationsName).length > 1);
	}
	
	$scope.saveAll = function(){
		$scope.submitted=true;
		if($scope.oneWayForm.$valid ){
			if($scope.oneWayAllowed){
				$scope.saveAllOneWayWithAmount();
			}else{
				$scope.removeAll();
			}
		}else{
			$scope.errorField={};
			for(i in $scope.oneWayForm.$error.required){
				$scope.errorField[$scope.oneWayForm.$error.required[i].$name]="input-error";
			}
			
			if($scope.amount<0 || !$scope.amount){
				$scope.errorField['allOneWayAmount']="input-error";
			}
		}
		$scope.notifyFormErrors($scope.oneWayForm.$error);
	}
	
	$scope.notifyChange = function(oneWayCharge) {
		oneWayCharge.hasChanged = true;
		if(!oneWayCharge.oneWayAllowed) {
			oneWayCharge.cost = null;
			oneWayCharge.free = null;
		}
	}
	
	$scope.updateValidation = function(field){
		if($scope.errorField!=undefined && $scope.errorField[field]){
			$scope.errorField[field]=null;
		}
	}
	
	$scope.saveAllOneWayWithAmount = function(){
		$scope.hasNotCharge==true?$scope.amount=0:$scope.amount=$scope.amount;
		$q.all([
				oneWayServiceAll.update({companyOid: $routeParams.oid, amount:$scope.amount}).$promise,
			]).then(function(response) {
			    gaService.notify("Autos_one_way", "permitir_one_way_general", ["Permite One Way"]);
				$scope.initialize();
				notificationService.notifyInfoByCode('oneWay.confirmationMessage.SUCCESS_SAVE');
			});	
	}
	
	$scope.removeAll = function(){
		$q.all([
				oneWayServiceAll.remove({companyOid: $routeParams.oid}).$promise,
			]).then(function(response) {
				gaService.notify("Autos_one_way", "permitir_one_way_general",["No Permite One Way"]);
				$scope.initialize();
				notificationService.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
			});	
	}
	
	$scope.save = function(oneWayCharge){
		oneWayCharge.companyOid=$routeParams.oid;
		if(oneWayCharge.oneWayAllowed==false){
			$scope.remove(oneWayCharge);
		}else{
			if(!oneWayCharge.oid){
				$scope.saveOneWay(oneWayCharge);
			}else{
				$scope.updateOneWay(oneWayCharge);
			}
		}
	}
	
	$scope.saveOneWay = function(oneWayCharge){
		oneWayService.post({companyOid: $routeParams.oid}, oneWayCharge)
			.$promise
			.then(function(response) {
				gaService.notify("Autos_one_way", "permitir_one_way_destino", ["Permite One Way"]);
                oneWayCharge.oid = response.oid;
				oneWayCharge.hasChanged = false;
				oneWayCharge.free = (oneWayCharge.cost == 0);
				notificationService.notifyInfoByCode('oneWay.confirmationMessage.SUCCESS_SAVE');
			});
	}
	
	$scope.updateOneWay = function(oneWayCharge){
				oneWayService.update({companyOid: $routeParams.oid},oneWayCharge)
					.$promise
					.then(function(response) {
				gaService.notify("Autos_one_way", "permitir_one_way_destino", ["Permite One Way"]);
				oneWayCharge.hasChanged = false;
				oneWayCharge.free = (oneWayCharge.cost == 0);
				notificationService.notifyInfoByCode('oneWay.confirmationMessage.SUCCESS_SAVE');
			});
	}
	
	$scope.remove = function(oneWayCharge){
		if(!oneWayCharge.oid) {
			oneWayCharge.cost = null;
			oneWayCharge.free = null;
			oneWayCharge.hasChanged = false;
			return;
		}
		$q.all([
				oneWayService.remove({companyOid: $routeParams.oid, oid: oneWayCharge.oid}).$promise,
			]).then(function(response) {
				gaService.notify("Autos_one_way", "permitir_one_way_destino", ["No Permite One Way"]);
				notificationService.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
				oneWayCharge.oid = null;
				oneWayCharge.hasChanged = false;
			});	
	}
	
	$scope.cancel = function(oneWayCharge){
		$scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function() {
			if(oneWayCharge.oid) {
				oneWayService.get({companyOid: $routeParams.oid, oid: oneWayCharge.oid }, function(originObject) {
					oneWayCharge.cost = originObject.cost;
					oneWayCharge.oneWayAllowed = originObject.oneWayAllowed;
					oneWayCharge.free = originObject.free;
					});
			}else {
				oneWayCharge.cost = null;
				oneWayCharge.oneWayAllowed = null;
				oneWayCharge.free = null;				
			}
			oneWayCharge.hasChanged = false;
		});
	}
	
	/*****VALIDATIONS******/
	
	$scope.valid = function(){
		var messages = $scope.validForms($scope.validCarName($scope.carSelected.name,"carName"));
		$scope.errorMessages = messages;
		return Object.keys(messages).length==0?true:false;
	}
	
	$scope.validCarName=function(carName, keyName){
		if($scope.carSelected.name != null || $scope.carSelected.name != undefined){
			return null;
		}
		response = {key:keyName, value:"Agregar nombre del auto"};
		return response;
	}
	
	
	$scope.validForms = function(){
		var i;
		var messages = [];
	    for (i = 0; i < arguments.length; i++) {
	    	response = arguments[i];
	    	if(response!=null){
	    		messages[response.key]=response.value;
	    	}
	    }
	    return messages;
	}

	/*********************/
	
	$scope.filterOneWay = function() {
		var items = $scope.originOneWayMap;
		var query = angular.lowercase($scope.oneWayQuery);
		$scope.oneWayMap = $filter('filter')(items, function(item) {
			
			var pickupLocationName = $scope.locationsName[item.pickupLocationOid];
			var dropoffLocationName = $scope.locationsName[item.dropoffLocationOid];
			
			if(item.cost != undefined) {
				if (angular.lowercase(pickupLocationName).indexOf(query) != -1 ||
						angular.lowercase(dropoffLocationName).indexOf(query) != -1 ||
						angular.lowercase(item.cost.toString()).indexOf(query) != -1) {

					return true;
				}
			} else {
				if (angular.lowercase(pickupLocationName).indexOf(query) != -1 ||
							angular.lowercase(dropoffLocationName).indexOf(query) != -1) {
					
					return true; 
				}
			}
			return false;
		});
		
		// ajuste del paginado.
		$scope.config.totalItems = $scope.oneWayMap.length;
		$scope.config.numPages = Math.floor($scope.oneWayMap.length / $scope.config.itemsPerPage);
		$scope.changePage();
	}
		
	$scope.initialize();
}]); 


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/one_way_controller.js
// module id = 915
// module chunks = 3